import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-email-content-drawer',
  templateUrl: './email-content-drawer.component.html',
  styleUrls: ['./email-content-drawer.component.scss'],
})
export class EmailContentDrawerComponent implements OnInit {
  @Input() content = '';
  htmlContent: any;

  constructor(
    private drawerRef: NzDrawerRef,
    private sanitizer: DomSanitizer,
  ) {}
  ngOnInit() {
    this.convertStringToHtml();
  }
  convertStringToHtml() {
    const htmlString = this.content;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(
      doc.body.innerHTML,
    );
  }
}
